import { batch } from 'react-redux';

// project imports
import gestopAPI from 'utils/gestopAPI';
import { dispatch } from 'store/index';
import { errorProcessor } from 'utils/processors';
import { logWorkOrderArchiveActions } from './slice';
import capabilities from './capabilities';

export const ApiLogWorkOrderArchiveGetCollection = async ({
    filters = [],
    orderBy = [],
    groupBy = [],
    page = 1,
    limit = 10,
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(logWorkOrderArchiveActions.startLoading());
    }

    await gestopAPI
        .post('log/workorderarchive/list', { filters, orderBy, groupBy, page, limit }, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(logWorkOrderArchiveActions.setList(response?.data?.list));
                    dispatch(logWorkOrderArchiveActions.setCount(response?.data?.count));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(logWorkOrderArchiveActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data?.list);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(logWorkOrderArchiveActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(logWorkOrderArchiveActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiLogWorkOrderArchiveCountCollection = async ({
    filters = [],
    successCallback = () => {},
    errorCallback = () => {},
    config = {}
}) => {
    await gestopAPI
        .post('log/workorderarchive/count', { filters }, config)
        .then((response) => {
            if (typeof successCallback === 'function') {
                successCallback(response?.data?.count);
            }
        })
        .catch((error) => {
            const errorMsg = errorProcessor(error?.response?.data);

            if (typeof errorCallback === 'function') {
                errorCallback(errorMsg);
            }
        });
};

export const ApiLogWorkOrderArchiveExportCollection = async ({
    exportType = 'allRows',
    format = 'pdf',
    columns = [],
    filters = [],
    orderBy = [],
    groupBy = [],
    successCallback = () => {},
    errorCallback = () => {},
    config = {}
}) => {
    if (capabilities.app.includes('exporter')) {
        dispatch(logWorkOrderArchiveActions.startExporting());
    }

    await gestopAPI
        .post(
            'log/workorderarchive/export',
            { exportType, format, columns, filters, orderBy, groupBy },
            { ...config, responseType: 'blob' }
        )
        .then((response) =>
            batch(() => {
                window.open(URL.createObjectURL(response?.data));

                if (capabilities.app.includes('exporter')) {
                    dispatch(logWorkOrderArchiveActions.stopExporting());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('exporter')) {
                    dispatch(logWorkOrderArchiveActions.stopExporting());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(logWorkOrderArchiveActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiLogWorkOrderArchiveExportItem = async ({ id, successCallback = () => {}, errorCallback = () => {}, config = {} }) => {
    if (capabilities.app.includes('exporter')) {
        dispatch(logWorkOrderArchiveActions.startExporting());
    }

    await gestopAPI
        .get(`log/workorderarchive/export/${id}`, { ...config, responseType: 'blob' })
        .then((response) =>
            batch(() => {
                window.open(URL.createObjectURL(response?.data));

                if (capabilities.app.includes('exporter')) {
                    dispatch(logWorkOrderArchiveActions.stopExporting());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('exporter')) {
                    dispatch(logWorkOrderArchiveActions.stopExporting());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(logWorkOrderArchiveActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiLogWorkOrderArchiveGetItem = async ({ id, successCallback = () => {}, errorCallback = () => {}, config = {} }) => {
    if (capabilities.app.includes('loader')) {
        dispatch(logWorkOrderArchiveActions.startLoading());
    }

    await gestopAPI
        .get(`log/workorderarchive/${id}`, config)
        .then((response) =>
            batch(() => {
                if (capabilities.app.includes('loader')) {
                    dispatch(logWorkOrderArchiveActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(logWorkOrderArchiveActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(logWorkOrderArchiveActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};
